import { I18n } from 'react-redux-i18n';

export const getPendingAdelantoQuotaWarning = (version) => {
    if (!version?.id) return null;

    const adelantos_pendientes = (version.adelantos_nex ?? []).filter(
        (item) => Number(item?.unidades_pendientes) > 0,
    );

    if (adelantos_pendientes.length === 0) return null;

    return {
        version: version.version,
        adelantos_pendientes,
    };
};

export const isPendingAdelantoQuotaConfirmationAccepted = (value) => value === 'SI';

export const formatAdelantoQuotaBalance = (item) => {
    if (item?.unidades_registradas != null && item?.unidades_comprometidas != null) {
        return `${item.unidades_registradas} de ${item.unidades_comprometidas}`;
    }

    const serializedBalance = item?.saldo_cupo_adelanto;
    if (typeof serializedBalance === 'string' && serializedBalance.includes('/')) {
        const [registered, committed] = serializedBalance.split('/');
        if (registered !== '' && committed !== '') return `${registered} de ${committed}`;
    }

    return serializedBalance ?? '—';
};

/**
 * Backend `contrato_version[].advertencia_cupo_adelanto_anterior` (tipo 9).
 * Shape: { contrato_version, version, adelantos_pendientes: AdelantoNEX[] } | null
 */
export const hasPreviousVersionQuotaPending = (warning) => {
    if (!warning || typeof warning !== 'object') return false;
    const items = warning.adelantos_pendientes;
    if (!Array.isArray(items) || items.length === 0) return false;
    return items.some((item) => Number(item?.unidades_pendientes) > 0);
};

export const formatPreviousVersionQuotaWarning = (warning) => {
    if (!warning || typeof warning !== 'object') return null;

    const items = warning.adelantos_pendientes;
    if (!Array.isArray(items) || items.length === 0) return null;

    const version = warning.version;
    if (version == null) return null;

    if (items.length === 1) {
        const { unidades_pendientes } = items[0];
        return I18n.t('contract.adelantoNex.warnings.previousVersionPending', {
            version,
            units: unidades_pendientes ?? 0,
            saldo: formatAdelantoQuotaBalance(items[0]),
        });
    }

    const details = items
        .map((item) =>
            I18n.t('contract.adelantoNex.warnings.previousVersionPendingLine', {
                units: item.unidades_pendientes ?? 0,
                saldo: formatAdelantoQuotaBalance(item),
            }),
        )
        .join('; ');

    return I18n.t('contract.adelantoNex.warnings.previousVersionPendingMulti', {
        version,
        details,
    });
};
